export function initManifestoPlugin() {
    // Cerchiamo se esiste almeno un wrapper del manifesto
    if (document.querySelector('.js-manifesto-reveal')) {
        // Import dinamico del file che contiene la logica pesante
        import('./manifesto.js')
            .then(module => module.default())
            .catch(err => console.error("Errore caricamento plugin Manifesto:", err));
    }
}
